import { MediaContentShowcaseItem } from "@onnit-js/ui/components/module/MediaContentShowcase";

const ingredientsFlowBlend: MediaContentShowcaseItem[] = [
    {
        image: "",
        imageWidth: 560,
        imageHeight: 560,
        title: "Omega-3 Fats",
        summary: "The essential fatty acids EPA and DHA.",
        detail:
            'Omega-3s play a critical role in healthy cell membrane structure and contribute to healthy cardiovascular function.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: "",
        imageWidth: 560,
        imageHeight: 560,
        title: "Astaxanthin",
        summary: "A type of carotenoid (a pigment found in the plants krill eat), astaxanthin gives krill, lobster, salmon, and shrimp their pink color.",
        detail: 'Helps provide antioxidant activity.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: "",
        imageWidth: 560,
        imageHeight: 560,
        title: "Phospholipids",
        summary:
            'A type of fat that makes up cell membranes. Phospholipids also help to regulate cell processes.<span class="oui-sup">&dagger;</span>',
        detail:
            'Literature suggests that when combined with omega-3s, phospholipids help the absorption of these healthy fats in the intestines.<span class="oui-sup">&dagger;</span>',
    },
];

export default ingredientsFlowBlend;
